module.exports = "/images/milano-9.jpg";